import React from 'react'

export default function Help() {
  return (
    <div>Help</div>
  )
}
